export default "__VITE_ASSET__D6XK6xMn__"